import Call from '../Call';
import {objToQs} from '../Utils';

const BidderCpc = {
    get(filters) {
        return Call(`bidderCpc?${objToQs(filters)}`);
    }
};

export default BidderCpc;


// WEBPACK FOOTER //
// ./src/services/API/components/BidderCPCCountry.js